import axiosInstance from "../axiosInstance";

export const obtenerPostventas = async () => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/postventa-obtenerPostventas`
  );
};
